import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router";
import Home from "./screens/home/home";
import PrivacyPolicy from "./screens/privacy-policy/privacy-policy";
import Error404 from "./components/error404";
import ItemDetails from "./screens/item-details/item-details";
import Reports from "./screens/reports/reports";
import PaymentCompleted from "./screens/payment-completed/payment-completed";
import ItemReports from "./screens/item-reports/item-reports";
import HelpScreen from "./screens/help/help";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <Error404 />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
    errorElement: <Error404 />,
  },
  {
    path: "/item-details/:itemId",
    element: <ItemDetails />,
    errorElement: <Error404 />,
  },
  {
    path: "/reports/:reportId",
    element: <Reports />,
    errorElement: <Error404 />,
  },
  {
    path: "/payment-completed/:sessionId",
    element: <PaymentCompleted />,
    errorElement: <Error404 />,
  },
  {
    path: "/item-reports/:reportId",
    element: <ItemReports />,
    errorElement: <Error404 />,
  },
  {
    path: "/help",
    element: <HelpScreen />,
    errorElement: <Error404 />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
